import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { LogIn } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { toast } from '../../hooks/use-toast';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, { username, password });
      localStorage.setItem('admin_token', response.data.token);
      toast({
        title: 'Success',
        description: 'Logged in successfully',
      });
      navigate('/admin/products');
    } catch (error) {
      console.error('Login error:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.detail || 'Invalid credentials',
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-rose-50 to-white flex items-center justify-center px-4">
      <Card className="w-full max-w-md border-rose-100 shadow-xl">
        <CardHeader className="text-center">
          <img
            src="https://customer-assets.emergentagent.com/job_studio-builder-12/artifacts/72mg2eao_%40theelenistudio.png"
            alt="Eleni Studio"
            className="w-24 h-24 mx-auto mb-4"
          />
          <CardTitle className="text-3xl font-serif text-rose-900">Admin Login</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-rose-900 mb-2">
                Username
              </label>
              <Input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter username"
                required
                className="border-rose-200 focus:border-rose-400"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-rose-900 mb-2">
                Password
              </label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                required
                className="border-rose-200 focus:border-rose-400"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-rose-800 hover:bg-rose-900 text-white py-6 text-lg"
            >
              <LogIn className="w-5 h-5 mr-2" />
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
